import { FC } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { IFormCheckboxProps } from './FormCheckbox.interface';

// @ts-ignore
const FormCheckbox: FC<IFormCheckboxProps> = ({
  className,
  label,
  input: { name, checked, onChange, ...otherInput },
  ...other
}) => (
  <FormControlLabel
    className={className}
    control={
      <Checkbox
        {...other}
        inputProps={otherInput}
        name={name}
        checked={checked}
        onChange={onChange}
      />
    }
    label={label}
  />
);

export default FormCheckbox;
